import React from 'react';
import { BaileyStill } from './bailey/BaileyAvatar';
import { staffLockedCopy } from '../pricing/usageRules';

/**
 * An employed team member the owner hasn't switched Bailey on for: one
 * clear card saying who to ask, never a blank page.
 */
export default function BaileyLocked({ status, frontDesk = false, onFrontDesk }) {
    const c = staffLockedCopy(status);
    return (
        <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: '40px 20px' }}>
            <div style={{ maxWidth: 440, width: '100%', textAlign: 'center' }}>
                <div style={{ width: 96, height: 96, margin: '0 auto 18px', borderRadius: '50%', background: '#F1EFEA', overflow: 'hidden', display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                    <BaileyStill appearance={status.appearance} />
                </div>
                <h1 style={{ fontSize: 24, fontWeight: 700, margin: '0 0 10px', color: '#29282D' }}>{c.title}</h1>
                <p style={{ fontSize: 15, lineHeight: 1.5, color: '#4B4B52', margin: '0 0 10px' }}>{c.text}</p>
                <p style={{ fontSize: 13, lineHeight: 1.5, color: '#7A7A80', margin: 0 }}>{c.note}</p>
                {frontDesk && (
                    <p style={{ fontSize: 14, lineHeight: 1.5, color: '#4B4B52', margin: '22px 0 0' }}>
                        <button type="button" onClick={onFrontDesk} style={{ border: 0, background: 'none', padding: 0, font: 'inherit', fontWeight: 600, color: '#006A87', textDecoration: 'underline', textUnderlineOffset: 3, cursor: 'pointer' }}>
                            Open the front desk
                        </button>
                    </p>
                )}
            </div>
        </div>
    );
}
